import interceptorAxios from './InterceptorAxios';

const ServicioUsuario={

    paginacion(objeto){
        return interceptorAxios.post('/usuario/paginacion.json',objeto);
    },

    cambiaContrasena(){
        return interceptorAxios.post('/usuario/cambia_contrasena.json');
    },

    actualizarContrasena(objeto){
        return interceptorAxios.post('/usuario/actualizar_contrasena.json',objeto);
    },
    enviarCodigo(objeto){
        return interceptorAxios.post('/usuario/verifica.json',objeto);
    },
    
    desactivar(objeto){
        return interceptorAxios.post('/usuario/desactivar.json',objeto);
    },

    activar(objeto){
        return interceptorAxios.post('/usuario/activar.json',objeto);
    },
    guardar_usuario_adninistrador(objeto){
        return interceptorAxios.post('/usuario/guardar_usuario_administrador.json',objeto);
    },
    editar_usuario_adninistrador(objeto){
        return interceptorAxios.post('/usuario/editar_usuario_administrador.json',objeto);
    },
    eliminar_usuario_admiminstrador(objeto){
        return interceptorAxios.post('/usuario/eliminar_usuario_administrador.json',objeto);
       
    }

}

export default ServicioUsuario;